import { createEntryPoint } from '#packages/apilib';
import { HiddenElementsScope } from './hiddenElementsScope';
import { HiddenElementsApi } from './hiddenElementsApi';
import { HiddenElementsApiKey } from './publicApiKey';
import { HiddenPanelOpenButton } from './components/hiddenPanelOpenButton/hiddenPanelOpenButton';

import mobileHiddenPanel from './components/mobileHiddenPanel';

export const HiddenElementsEntryPoint = createEntryPoint({
  name: 'HiddenElements',
  Scope: HiddenElementsScope,
  publicApi({ contributeApi }) {
    contributeApi(HiddenElementsApiKey, HiddenElementsApi);
  },
  async initialize(scope: HiddenElementsScope) {
    const { workspace } = scope;

    workspace.contributeMouseCatcherComponent(HiddenPanelOpenButton);
  },
});

export const panels = {
  mobileHiddenPanel,
};
